import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import * as _ from 'lodash';
import { db } from 'src/app/db/db';
import { EEntreeProcessType } from 'src/app/domain/enums/entree-process-type';
import { EEntreeZoneType } from 'src/app/domain/enums/entree-zone';
import { EEPIType } from 'src/app/domain/enums/epi-type';
import { EExpositionClimatique } from 'src/app/domain/enums/exposition-climatique';
import { EMeteoType } from 'src/app/domain/enums/meteo-type';
import { ZoneMeasure } from 'src/app/domain/zone-measure';
import { StringConverter } from '../string-converter';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-copy-ph-between-zones-box',
    templateUrl: './copy-ph-between-zones-box.html',
    styleUrls: ['./copy-ph-between-zones-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CopyPlageHorraireBetweenZonesBoxDialog implements OnInit {

    public AvailableMeasure: ZoneMeasure[] = []
    SelectedMeasure?: ZoneMeasure;

    constructor(
        private snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<CopyPlageHorraireBetweenZonesBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (data) {
            this.getZoneInformation(data.zoneCode, data.currentMeasureCode, data.isDepose);
        }
    }

    getExpositionLabel(type: EExpositionClimatique) {
        return StringConverter.getExpositionClimatiqueTypeName(type)
    }

    getMeteoLabel(type: EMeteoType) {
        return StringConverter.getMeteoTypeName(type)
    }

    getEPILabel(type: EEPIType) {
        return StringConverter.getEPITypeName(type)
    }

    getEntreZoneLabel(type: EEntreeZoneType | EEntreeProcessType) {
        return StringConverter.getEntreZoneTypeName(type as EEntreeZoneType)
    }

    async ngOnInit() {

    }

    async getZoneInformation(zoneCode: string, currentMeasureCode: string, isDepose: boolean) {
        const zone = await db.getZoneByCodeWithChildren(zoneCode, isDepose);
        this.AvailableMeasure = zone.ZoneMesureList;
        _.remove(this.AvailableMeasure, x => x.Code === currentMeasureCode);
    }

    canSave() {
        return true;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.SelectedMeasure);
    }
}
